module.exports = __webpack_public_path__ + "img/mavio-web-logo.6caeb22a.svg";